export const UPDATE_NAME = 'profile/UPDATE_NAME';
export const UPDATE_EMAIL = 'profile/UPDATE_EMAIL';
export const UPDATE_GENDER = 'profile/UPDATE_GENDER';
export const UPDATE_PHONE = 'profile/UPDATE_PHONE';
export const UPDATE_CITY = 'profile/UPDATE_CITY';
export const UPDATE_ADDRESS = 'profile/UPDATE_ADDRESS';
export const UPDATE_TAIWAN_CITY = 'profile/UPDATE_TAIWAN_CITY';